// pages/Dashboard.jsx
import Layout from "../components/Layout";

export default function Dashboard() {
  return (
    <Layout>
      <h1 className="dashboard-title">Dashboard</h1>
      <div className="card-grid">
        <div className="card">
          <h3>Revenue</h3>
          <p>$12,628</p>
        </div>
        <div className="card">
          <h3>Expenses</h3>
          <p>$4,679</p>
        </div>
        <div className="card">
          <h3>Transactions</h3>
          <p>$14,857</p>
        </div>
      </div>
    </Layout>
  );
}
